import React, { useContext, useEffect, useState } from 'react';
import {
    GelSpinner
} from '@tal-gel/components';

import { getGelTokens } from '@tal-gel/theming';
import { useParams } from 'react-router-dom';
import { CorroLinkGraphQL, START_CORRO_LINK_MUTATION } from '../../graphql/mutations/graphql-corrolink';
import { CorroLinkFileResult, StartCorroLink } from './CorroLinkModels';
import { ThemeContext } from '../../common/usercontext/themes.context';
import { THEME_NAME } from '../../constants/constants';
import { useCookies } from 'react-cookie';
import VerifyCorroLinkIdentity from './views/VerifyCorroLinkIdentity';
import InvalidCorroLink from './views/InvalidCorroLink';
import CorroAttachmentList from './views/CorroAttachmentList';

const CorroLinkPage: React.FC = () => {
    const { } = getGelTokens()
    const { setThemeContext } = useContext(ThemeContext);
    const [_, setssoCookies] = useCookies(['tpid']);

    let { trackingId } = useParams();

    const [startCorroLinkLoaded, setStartCorroLinkLoaded] = useState(false);
    const [invalidCorroLink, setInvalidCorroLink] = useState(false);
    const [sessionId, setSessionId] = useState("");

    const [fileResults, setFileResults] =
        useState<CorroLinkFileResult | null>(null);

    useEffect(() => {
        CorroLinkGraphQL<{ trackingId: string | undefined }, StartCorroLink>(
            START_CORRO_LINK_MUTATION,
            { trackingId }
        )
            .then(startCorroResp => {
                console.log("CorroLinkGraphQL response: ", startCorroResp)

                setStartCorroLinkLoaded(true);

                // Set contentful tag
                setssoCookies('tpid', startCorroResp.cmsTag, {
                    path: "/",
                    sameSite: "lax",
                    secure: true,
                });

                // Set GEL theme
                setThemeContext({
                    theme: startCorroResp.themeName,
                    fund: THEME_NAME.TAL
                });

                setSessionId(startCorroResp.sessionId);
            })
            .catch(() => {
                setStartCorroLinkLoaded(true);
                setInvalidCorroLink(true);
            })

    }, [trackingId])

    if (!startCorroLinkLoaded) return <GelSpinner medium overlay />

    if (invalidCorroLink) return <InvalidCorroLink />

    return fileResults ?
        <CorroAttachmentList
            fileResult={fileResults} /> :
        <VerifyCorroLinkIdentity
            trackingId={trackingId!}
            sessionId={sessionId}
            setFileResults={setFileResults} />
}

export default CorroLinkPage;